import React, { useEffect } from "react";

const LINKS = {
    android: "https://play.google.com/store/apps/details?id=az.pulpal.user",
    ios: "https://apps.apple.com/az/app/pulpal/id6446308620",
    desktop: "https://pulpal.az/",
};

function getDevice() {
    const ua = (navigator.userAgent || "").toLowerCase();
    const isAndroid = ua.includes("android");
    const isIOS = /iphone|ipad|ipod/.test(ua);
    return isAndroid ? "android" : isIOS ? "ios" : "desktop";
}

export default function MobileOpenApp() {
    useEffect(() => {
        const device = getDevice();
        const url = LINKS[device] || LINKS.desktop;

        window.location.replace(url);
    }, []);

    return (
        <div style={{ padding: 24 }}>
            Yönləndirilirsiniz...
        </div>
    );
}
